import { supabase } from './supabaseClient';

export const scanJobs = async (title) => {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Unauthorized: User not logged in");
  }

  const response = await fetch("/.netlify/functions/scan_jobs", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ title })
  });

  if (!response.ok) {
    const errorText = await response.text();
    let errorMsg = response.statusText;
    try {
      const errorData = JSON.parse(errorText);
      errorMsg = errorData.error || errorMsg;
      if (typeof errorMsg === 'object') {
          errorMsg = errorMsg.message || JSON.stringify(errorMsg);
      }
    } catch (e) {
      errorMsg = errorText || errorMsg;
    }
    throw new Error(`Scan Jobs API error: ${errorMsg}`);
  }

  const responseText = await response.text();
  try {
    const data = JSON.parse(responseText);
    return typeof data === 'string' ? JSON.parse(data) : data;
  } catch (e) {
    return responseText;
  }
};

export const callOpenAI = async (systemPrompt, userPrompt) => {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  if (!token) {
    throw new Error("Unauthorized: User not logged in");
  }

  const response = await fetch("/.netlify/functions/openai", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify({ systemPrompt, userPrompt })
  });

  if (!response.ok) {
    const errorText = await response.text();
    // Parse nested error strings if applicable
    let errorMsg = response.statusText;
    try {
      const errorData = JSON.parse(errorText);
      errorMsg = errorData.error || errorMsg;
      if (typeof errorMsg === 'object') {
          errorMsg = errorMsg.message || JSON.stringify(errorMsg);
      }
    } catch (e) {
      errorMsg = errorText || errorMsg;
    }
    throw new Error(`OpenAI API error: ${errorMsg}`);
  }

  const responseText = await response.text();
  try {
    const data = JSON.parse(responseText);
    return typeof data === 'string' ? JSON.parse(data) : data;
  } catch (e) {
    return responseText;
  }
};
